import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconActivity: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.6636 13.8085C15.5945 13.7192 15.5267 13.6299 15.46 13.5438C14.5442 12.3558 13.99 11.6388 13.99 8.27589C13.99 6.53482 13.6016 5.10625 12.836 4.03482C12.2715 3.2433 11.5084 2.64286 10.5026 2.19911C10.4896 2.19139 10.4781 2.18126 10.4684 2.1692C10.1067 0.870089 9.11666 0 8.0001 0C6.88355 0 5.89397 0.870089 5.53219 2.16786C5.52254 2.17948 5.51114 2.18928 5.49847 2.19688C3.15129 3.23304 2.01058 5.22098 2.01058 8.27455C2.01058 11.6388 1.4573 12.3558 0.540577 13.5424C0.473967 13.6286 0.406108 13.7161 0.336999 13.8071C-0.0275165 14.2785 -0.103095 14.9342 0.143413 15.4866C0.400279 16.067 0.947733 16.4272 1.57262 16.4272H14.4322C15.0541 16.4272 15.5978 16.0674 15.8555 15.4897C16.1031 14.9372 16.0282 14.2807 15.6636 13.8085Z" />
      <path d="M8.0001 20C9.22574 19.9989 10.352 19.2766 10.9326 18.1192C10.9756 18.032 10.9446 17.924 10.8633 17.8779C10.8392 17.8642 10.8124 17.8571 10.7852 17.8571H5.21579C5.12382 17.8568 5.049 17.9365 5.04868 18.0351C5.04859 18.0644 5.05522 18.0933 5.068 18.1192C5.6486 19.2765 6.77461 19.9988 8.0001 20Z" />
    </svg>
  </IconStyled>
);

IconActivity.defaultProps = iconDefaultProps;
IconActivity.displayName = 'IconActivity';

export default IconActivity;
